import { createClient } from '@supabase/supabase-js';
import { authStorageAdapter } from './persistence.js';
export function createSupabaseAuthClient(url, anonKey) {
    return createClient(url, anonKey, {
        auth: {
            detectSessionInUrl: true,
            persistSession: true,
            autoRefreshToken: true,
            flowType: 'pkce',
            storage: authStorageAdapter,
        },
    });
}
//# sourceMappingURL=create-client.js.map